<template>
    <div class="Report">
        <component
            v-if="resultsCount > 0"
            :is="mappedReport"
            :report="report"
            :timeZone="timeZone"
            :isClarkLlc="isClarkLlc"
            class="report"
        />
        <div v-else class="empty">
            <h1>No results</h1>
        </div>
    </div>
</template>

<script>
import HaulingReport from './HaulingReport';
import TicketReport from './TicketReport';
import TimesheetReport from './TimesheetReport';
import ProjectReport from './ProjectReport';
import MaterialReport from './MaterialReport';
import DetailedHaulingReport from './DetailedHaulingReport';

const REPORTS_MAP = {
    hauling: HaulingReport,
    tickets: TicketReport,
    timesheets: TimesheetReport,
    projects: ProjectReport,
    materials: MaterialReport,
    detailedHauling: DetailedHaulingReport,
};

export default {
    name: 'Report',

    data: () => ({
        report: undefined,
        resultsCount: 0,
        type: undefined,
        includePhotos: false,
        timeZone: undefined,
        isClarkLlc: false,
    }),

    computed: {
        mappedReport() {
            return REPORTS_MAP[this.type];
        },
    },

    mounted() {
        window.addEventListener('message', (event) => {
            // Validate event data to prevent overwriting with invalid report data.
            if (event?.data?.report) {
                this.report = event.data.report;
                this.type = event.data.type;
                this.includePhotos = event.data.includePhotos;
                this.resultsCount = event.data.resultsCount;
                this.timeZone = event.data.timeZone;
                
                // HACK: This is a temporary solution but passing it through
                // the event data since vuex is not available in the iframe
                this.isClarkLlc = event.data.isClarkLlc;
            }
        });
    },

    beforeDestroy() {
        window.removeEventListener('message');
    },
}
</script>

<style lang="scss">
@import 'globals.scss';

* {
    line-height: 1;
    font-family: sans-serif;
    text-rendering: optimizeLegibility;
}

.page {
    position: relative;
    page-break-after: always;
    break-after: page;

    @media print {
        // Prevents content overflow issues
        min-height: 99vh;
        padding: 0;
    }
}

.pageBreak {
    page-break-before: always;
}

@media print {
    html, body, #app {
        height: 100%;
    }

    tr {
        -webkit-column-break-inside: avoid;
        page-break-inside: avoid;
        break-inside: avoid;
    }
}
</style>

<style lang="scss">
@import 'globals.scss';

.Report {
    height: 100%;
    background-color: $bg-color-1;

    .report {
        padding: $admin-gutter;
        height: 100%;

        @media print {
            padding: 0;
            font-size: 10px;
        }

        table {
            width: 100%;
            border-spacing: 0;
        }

        table.main td {
            height: 2em;
        }

        tr {
            -webkit-column-break-inside: avoid;
            page-break-inside: avoid;
            break-inside: avoid;
        }

        th, td {
            border: 1px solid #000;
            padding: 0.5em;
            text-align: center;

            @media print {
                padding: 0.5 0;
            }
        }

        tfoot th {
            border: none;
        }

        .meta {
            width: 100%;
        }

        .meta:after {
            content: '';
            display: block;
            clear: both;
        }

        .third {
            float: left;
            width: 33.333%;
        }

        .half {
            float: left;
            width: 50%;
        }

        .meta table td:last-child {
            width: 40%;
        }

        .meta table td:first-child {
            width: 60%;
            border: none;
            text-align: right;
        }
    }

    .empty {
        padding: $admin-gutter;
        text-align: center;
        color: $text-color-muted;
    }
}
</style>
